import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context';

/**
 * ProtectedRoute - Wraps routes that require authentication
 * Redirects to login if user is not authenticated
 * Enforces: login → email verification → onboarding → app
 */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show nothing while checking auth status
  if (loading) {
    return (
      <div className="page-loader">
        <div className="page-loader__spinner"></div>
      </div>
    );
  }

  // Not authenticated - redirect to login with return URL
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Email not verified - redirect to verification page
  if (user.email_verified === false) {
    return <Navigate to="/verification-pending" replace />;
  }

  // Onboarding not completed - redirect to onboarding (but allow /onboarding itself)
  if (user.onboarding_completed === false && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  // Authenticated, verified, and onboarded - render the protected content
  return children;
}

export default ProtectedRoute;
